// extracted by mini-css-extract-plugin
export var line = "SectionDivider-module__line___peBQr";
export var text = "SectionDivider-module__text___RqYoS";
export var wrapper = "SectionDivider-module__wrapper___Oz7yY";